<template>
  <!--灰色头部组件-->
  <tkui-header center class="grey-header" slot="header">
    <div slot="left-menu" @click="handleGoBack">
      <tkui-button class="icon">
        <tk-icon size="16" color="#666">{{icon}}</tk-icon>
      </tkui-button>
    </div>
    {{title}}
    <!--插槽-->
    <slot name="center-menu"></slot>
    <slot slot="right" name="right-menu"></slot>
  </tkui-header>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'fanhui'
    },
    title: {
      type: String
    }
  },
  methods: {
    /**
     * 如果不绑定方法只执行返回操作
     * @date: 2020/3/9
     */
    handleGoBack () {
      this.$listeners.watchBack !== undefined ? this.$listeners.watchBack() : this.$back()
    }
  }
}
</script>

<style lang="scss" scoped>
  .grey-header {
    background: #ffff !important;
    padding-top: 20px !important;
  }
</style>
